import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListComponent } from '../list-component';
import { HubReport } from '../../interfaces/hub-reports/hub-report';
import { HubReportsService } from '../../services/hub-reports/hub-reports.service';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-hub-reports-v2-grid',
  templateUrl: './hub-reports-v2-grid.component.html',
  styleUrl: './hub-reports-v2-grid.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HubReportsV2GridComponent extends ListComponent<HubReport> {
  protected columnsToDisplay = [
    'reference',
    'jurisdiction',
    'country',
    'view'
  ];
  protected expandedHubReport: HubReport | null = null;

  constructor(
    repo: HubReportsService,
    private router: Router) {
    super(repo);
  }

  getJurisdiction(hubReport: HubReport) {
    if (hubReport.jurisdiction === '_F') {
      return 'FED';
    } else {
      return hubReport.jurisdiction;
    }
  }

  protected viewHubReport(hubReport: HubReport, newTab: boolean) {
    if (newTab) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['hubreportsv2', hubReport.id]) //UBO2TODO: fix path
      );

      window.open(url, '_blank');
    } else {
      this.router.navigate(['hubreportsv2', hubReport.id]) //UBO2TODO: fix path
    }
  }
}
